// База знаний: чистые помощники экрана — разбор текста статьи, подсветка, примеры вопросов.

// Текст статьи: абзацы через пустую строку, строки «- » — список.
export function parseBody(text) {
  const blocks = []
  for (const chunk of String(text || '').split(/\n{2,}/)) {
    const lines = chunk.split('\n').map((l) => l.trim()).filter(Boolean)
    if (!lines.length) continue
    if (lines.every((l) => l.startsWith('- '))) {
      blocks.push({ type: 'list', items: lines.map((l) => l.slice(2)) })
    } else {
      blocks.push({ type: 'p', text: lines.join(' ') })
    }
  }
  return blocks
}

function norm(text) {
  return String(text ?? '').toLowerCase().replace(/ё/g, 'е')
}

// Подсветка слов запроса (по началу слова, без окончаний) — сегменты без HTML, безопасно.
export function highlight(text, query) {
  const source = String(text ?? '')
  const roots = norm(query).split(/[^a-zа-я0-9:]+/).filter((w) => w.length >= 3)
    .map((w) => (w.length > 5 ? w.slice(0, w.length - 2) : w))
  if (!roots.length || !source) return [{ text: source, hit: false }]
  const lower = norm(source)
  const marks = new Array(source.length).fill(false)
  for (const root of roots) {
    let from = 0
    for (;;) {
      const at = lower.indexOf(root, from)
      if (at < 0) break
      const startOfWord = at === 0 || /[^a-zа-я0-9]/.test(lower[at - 1])
      if (startOfWord) for (let i = at; i < at + root.length; i += 1) marks[i] = true
      from = at + root.length
    }
  }
  const out = []
  for (let i = 0; i < source.length; i += 1) {
    const last = out[out.length - 1]
    if (last && last.hit === marks[i]) last.text += source[i]
    else out.push({ text: source[i], hit: marks[i] })
  }
  return out
}

export const EXAMPLES = [
  'Что будет, если завод отменил рейс в 17:00 накануне?',
  'Почему ИП в TMS стоит как собственность?',
  'До скольки вносить реального водителя?',
  'Что значит метка «Получено из TMS»?',
  'Рейса нет в ERP — где он?',
  'Как работает Торг Транс?',
]

export function nextExample(index) {
  return EXAMPLES[(Number(index) + 1) % EXAMPLES.length]
}

export function debounce(fn, ms = 250) {
  let timer = null
  const wrapped = (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), ms)
  }
  wrapped.cancel = () => clearTimeout(timer)
  return wrapped
}

export const ACCESS_TONES = { all: 'all', leads: 'leads', commercial: 'commercial' }
